import { render } from "./GroButton.vue?vue&type=template&id=34f52f80&scoped=true"
import script from "./GroButton.vue?vue&type=script&lang=js"
export * from "./GroButton.vue?vue&type=script&lang=js"

import "./GroButton.vue?vue&type=style&index=0&id=34f52f80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34f52f80"

export default script